import { create } from "zustand"

interface ProductAllocationRefetchStore {
	refetchFlag: number
	requestRefetch: () => void
}

export const useProductAllocationRefetchStore =
	create<ProductAllocationRefetchStore>(set => ({
		refetchFlag: 0,

		requestRefetch: () =>
			set(state => ({ refetchFlag: state.refetchFlag + 1 })),
	}))
